import * as jwt_decode from "jwt-decode";

import { Spin } from "antd";
import { notification } from "helpers/notification";
// import { GlobalState } from "config/global";
import { LANDING_PAGE_ROUTE } from "config/route-consts";
import { getParameterByName } from "helpers/query";
import * as Cookie from "js-cookie";
// import { AppUser } from "models/AppUser";
import "./Login.scss";
// import { setGlobal } from "reactn";
import { externalAuthenticationRepository } from "repositories/external-authentication-repository";
const qs = require("qs"); 
interface DecodedToken {
  exp: number;
}

export default function LoginSSOWaitingPage() {
  const { code, session_state } = qs.parse(window.location.search.substring(1));
  if (code && session_state) {
    Cookie.remove("RefreshToken");
    Cookie.remove("AccessToken");
    const redirectUrl = `${window.location.protocol}//${window.location.host}${process.env.REACT_APP_PREFIX_URL}/login-sso-waiting-page`;
    externalAuthenticationRepository.login(code, redirectUrl).subscribe((res) => {
      // Decode the token to get the expiration time
      const decodedToken = jwt_decode.default(res.accessToken) as DecodedToken;
      const expiresAt = new Date(decodedToken.exp * 1000);

      // Set cookies with the decoded expiration
      Cookie.set("Token", res.accessToken, {
        domain: `${process.env.REACT_APP_URI_COOKIE}`,
        expires: expiresAt,
      });
      Cookie.set("access_token", res.accessToken, {
        domain: `${process.env.REACT_APP_URI_COOKIE}`,
        expires: expiresAt,
      });
      Cookie.set("refreshToken", res.refreshToken, {
        domain: `${process.env.REACT_APP_URI_COOKIE}`,
        expires: expiresAt,
      });

      const redirect =
        getParameterByName("redirect") === null
          ? LANDING_PAGE_ROUTE
          : getParameterByName("redirect");
      window.location.href = `${redirect}`;

        /*externalAuthenticationRepository
          .getUserInfo()
          .subscribe((result: AppUser) => {
            if (result) {
              notification.success({
                message: "Login success",
              });
              setGlobal<GlobalState>({
                user: result,
              });
              localStorage.setItem("currentUserInfo", JSON.stringify(result));
              const redirect =
                getParameterByName("redirect") === null
                  ? LANDING_PAGE_ROUTE
                  : getParameterByName("redirect");
              window.location.href = `${redirect}`;
            }
          });*/
      },
      (err) => {
        notification.error({
          message: "Login failed",
        });
        Cookie.remove("access_token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("refreshToken", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("Token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        window.location.href = `${process.env.REACT_APP_KEYCLOAK_URL}/logout?redirect_uri=${process.env.REACT_APP_DOMAIN}${process.env.REACT_APP_DEFAULT_DIRECT_URI}`;
      }
    );
  }

  return (
    <div className="login-sso-waiting-page">
      <Spin spinning={true}></Spin>
    </div>
  );
}
